import { isPossiblePhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export function getFormattedPhoneAndURI(phone?: string) {
    if (!phone) {
        return {
            formatted: null,
            uri: null
        };
    }
    const phonePrepared = `+${phone.trim().replace('+', '').replace(' ', '')}`;
    const isPhoneNumber = isPossiblePhoneNumber(phonePrepared);
    if (isPhoneNumber) {
        let phoneFormatted = phone,
            phoneURI = `tel:${phone}`;
        try {
            const phoneNumber = isPossiblePhoneNumber(phonePrepared) ? parsePhoneNumber(phonePrepared) : undefined;
            phoneFormatted = phoneNumber?.formatInternational() ?? phonePrepared;
            phoneURI = phoneNumber?.getURI() ?? phonePrepared;
        } catch {
            // skip
        }
        return {
            formatted: phoneFormatted,
            uri: phoneURI
        };
    }
    return {
        formatted: phone,
        uri: `tel:${phone}`
    };
}
